export const VIEWONLY = "View Only Admin";
export const MANAGE = "manage";
export const AFFILIATED_ADMIN = "Affiliated Admin";
export const USE_AFFILIATED_ADMIN_FILTERS = "USE_AFFILIATED_ADMIN_FILTERS";
export const VIEW_SUMMARY_REPORT = "VIEW_SUMMARY_REPORT";
